export default __webpack_public_path__ + "static/young-toddler7-ab51f4531861b560b8fe0e9430feeed5.jpg";